import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Ratingstar = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M11.4094 3.17969C11.6846 2.60677 12.5038 2.60677 12.7791 3.17969L15.1477 8.10966C15.2585 8.34032 15.4789 8.49956 15.7336 8.5329L21.1832 9.24637C21.8168 9.32933 22.0702 10.1071 21.6062 10.5446L17.6221 14.3009C17.4351 14.4772 17.3506 14.7357 17.3976 14.9877L18.3982 20.3544C18.5147 20.9793 17.8517 21.4596 17.2903 21.157L12.4557 18.5509C12.2302 18.4294 11.9583 18.4294 11.7328 18.5509L6.89817 21.157C6.33681 21.4596 5.67379 20.9793 5.79029 20.3544L6.79085 14.9877C6.83784 14.7357 6.75335 14.4772 6.56642 14.3009L2.5823 10.5446C2.11824 10.1071 2.37167 9.32933 3.00531 9.24637L8.45493 8.5329C8.70955 8.49956 8.92998 8.34032 9.0408 8.10966L11.4094 3.17969Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        d='M13.3609 2.85429C12.8133 1.71442 11.1868 1.71442 10.6392 2.85429L8.27059 7.78426C8.27059 7.78426 8.2678 7.78806 8.26338 7.78864L2.81377 8.50211C1.55797 8.66652 1.04591 10.2151 1.97361 11.0897L5.95774 14.846C5.95953 14.8477 5.95937 14.8496 5.95937 14.8496L4.95881 20.2163C4.72535 21.4685 6.05062 22.4145 7.15985 21.8166L11.9945 19.2105C11.9978 19.2087 12.0023 19.2087 12.0056 19.2105L16.8403 21.8166C17.9495 22.4145 19.2747 21.4685 19.0413 20.2163L18.0407 14.8496C18.0407 14.8496 18.0406 14.8477 18.0424 14.846L22.0265 11.0897C22.9542 10.2151 22.4421 8.66652 21.1863 8.50211L15.7367 7.78864C15.7323 7.78806 15.7295 7.78426 15.7295 7.78426L13.3609 2.85429Z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
